// extracted by mini-css-extract-plugin
export default {"header":"CenteredHeader_header__qc7ay","subheader":"CenteredHeader_subheader__5ZtW4"};